// (앱) 수업 리뷰 > AI 진단 개요 - 내가 집중하고 싶은 학습 영역
import { useCallback, useEffect, useState } from 'react'
import { HighlightOverviewResponse, SummaryHighlightPerMetricItem } from '../../../../../model/caf.interface'
import { useCafHighlightListV5 } from '../../../../../modules/apis/webview/caf'
import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import useIsMobile from '../../../../../modules/hooks/common/useIsMobile'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'

import { useLessonsStack } from '../../../../../pages/[lang]/webview/lessons'
import FilterChipBtn from '../../../../new-portal/caf/common/BottomSheet/FilterChipBtn'
import SortResultList from '../../../../new-portal/caf/highlight/list/SortResultList'
import WebviewStackContainer from '../../../common/WebviewStackContainer'

const AIOverviewHighlightListActivity = ({ params }) => {
  const { useLessonsFlow } = useLessonsStack()
  const { pop } = useLessonsFlow()
  const { lessonId, pinned } = params
  const { t } = useTranslation()
  const [edit, setEdit] = useState(false)
  const isMobile = useIsMobile()
  const router = useAppRouter()

  const { data, refetch } = useCafHighlightListV5<HighlightOverviewResponse>({
    lessonId: +lessonId,
    pinned: false,
    recommended: false,
    show_details: false,
  })
  const [selectedFilterId, setSelectedFilterId] = useState('recommended')

  const mutateData = useCallback(
    (dt): SummaryHighlightPerMetricItem[] =>
      dt?.map((item) => {
        return {
          ...item,
          zscore_sum: item.zscore, //map
          average_count: item.count,
          tag: item.highlight_tag,
        }
      }),
    []
  )

  useEffect(() => {
    setEdit(pinned)
  }, [pinned])

  const handleEdit = () => {
    setEdit((prev) => !prev)
  }
  const onChangeFilter = (option) => {
    setSelectedFilterId(option)
  }
  const filteredPinnedNum = data?.highlights?.filter((item) => item.is_pinned)?.length

  return (
    <div>
      <WebviewStackContainer
        height="52px"
        onBack={pop}
        appendRight={() => (
          <div className="fixed right-[17px] z-[999]" onClick={handleEdit}>
            {edit ? (
              <span className="text-14 text-gray-700">{t(n_caf.highlight_list_edit.done)}</span>
            ) : (
              <span className="text-14 text-gray-700">{t(n_caf.highlight_list.edit)}</span>
            )}
          </div>
        )}
        title={edit ? t(n_caf.highlight_list_edit.title) : t(n_caf.highlight_list.title)}
        border={true}
      >
        <div className="mt-20 mb-[50px] px-20">
          <div className="mb-24 flex items-center justify-between">
            <FilterChipBtn state={[selectedFilterId, onChangeFilter]} />
            {edit ? (
              <span className="text-14 text-gray-700">{t(n_caf.highlight_list_edit.count(filteredPinnedNum))}</span>
            ) : (
              <span className="text-14 text-gray-700">{t(n_caf.highlight_list.count)}</span>
            )}
          </div>
          {edit && (
            <div className="border-1 text-14 mb-24 flex justify-center rounded-md border-gray-200 bg-gray-50 py-12 text-gray-700">
              {t(n_caf.highlight_list_edit.info)}
            </div>
          )}
          {data && (
            <SortResultList
              filterId={selectedFilterId}
              dataArr={mutateData(data.highlights)}
              detail={true}
              edit={edit}
              refetch={refetch}
              from={'lesson'}
            />
          )}
        </div>
      </WebviewStackContainer>
    </div>
  )
}

export default AIOverviewHighlightListActivity
